'use strict';

var baseTable = require('./base-table'); // this creates a map for code as hexString -> codecName


var nameTable = {};
module.exports = nameTable;

for (var encodingName in baseTable) {
  var code = baseTable[encodingName];
  nameTable[code.toString('hex')] = encodingName;
}